import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import FormattedInvoicePropertyLabelAndValue from 'invoices-ui-lib/components/FormattedInvoicePropertyLabelAndValue';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "NonNativeInvoiceHighlight__StyledDiv",
  componentId: "sc-1ck4rqr-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    textAlign: 'left',
    marginTop: theme.space['400'],
    marginBottom: theme.space['400']
  };
});
const NonNativeInvoiceHighlight = ({
  invoice,
  propertyDefinitions
}) => {
  const relevantHeaderPropertyName = getInvoiceProperty(invoice, 'hs_number') ? 'hs_number' : 'hs_title';
  const relevantStatusPropertyName = getInvoiceProperty(invoice, 'hs_status') ? 'hs_status' : 'hs_invoice_status';
  return /*#__PURE__*/_jsxs(StyledDiv, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h3",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-header-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: relevantHeaderPropertyName,
        displayLabel: false
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-amount-billed-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_amount_billed"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-status-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: relevantStatusPropertyName
      })
    })]
  });
};
export default NonNativeInvoiceHighlight;